import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import { useDispatch } from 'react-redux';
import { handleGetRequest } from '../../../service/GetTemplate';
import { endPoints } from '../../../Config';
import { useNavigate } from 'react-router-dom';

const MerchantApprovals = () => {
    const [allMerchants, setAllMerchants] = useState([]);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const actionBodyTemplate = (rowData) => {
        return (
            <>
                <div className="actions">
                    <Button
                        tooltip="Edit"
                        icon="pi pi-pencil"
                        tooltipOptions={{ position: 'top' }}
                        disabled={['Pending', 'Rejected'].includes(rowData?.statusName) || (rowData?.statusName === 'Approved' && rowData?.isActive === 'N') ? true : false}
                        onClick={() => {
                            navigate('/merchant-approval-edit', { state: { rowData } });
                        }}
                        className="p-button-rounded p-button-primary mr-2 ml-2"
                    />
                    <Button
                        tooltip="View Details"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-eye"
                        onClick={() => {
                            navigate('/merchant-approval-view');
                        }}
                        className="p-button-rounded"
                        style={{ backgroundColor: '#F2AC57', border: 'none' }}
                    />
                </div>
            </>
        );
    };

    const getMerchantList = async () => {
        const response = await handleGetRequest(endPoints.getallMerchants, true, false, dispatch);
        if (response) {
            const draftMerchants = response?.data?.filter((merchant) => merchant.status === 'Pending');
            setAllMerchants(draftMerchants);
        }
    };
    useEffect(() => {
        getMerchantList();
    }, []);

    return (
        <div className="p-4">
            <div className="flex justify-content-between align-items-center mb-3">
                <h3>Merchants Approval</h3>
            </div>
            <DataTable
                paginator
                rows={15}
                rowsPerPageOptions={[5, 10, 20]}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Records"
                emptyMessage="No List found."
                responsiveLayout="scroll"
                value={allMerchants}
                className="p-datatable-sm datatable-responsive"
            >
                <Column field="pocName" header="POC Name" />
                <Column field="pocEmail" header="POC Email" />
                <Column field="companyName" header="Company Name" />
                <Column field="companyEmail" header="Company Email" />
                <Column field="companyEmail" header="Company Email" />
                <Column field="status" header="Status" />
                <Column header="Actions" body={actionBodyTemplate} className="Table__ActionHeading__CentredAlign" />
            </DataTable>
        </div>
    );
};

export default MerchantApprovals;
